export default __webpack_public_path__ + "static/media/kid.dea082ba.png";